"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6432],{

/***/ 6195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ AuthFormWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46574);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62623);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28492);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);



var AuthFormWrapper = function(param) {
    var title = param.title, _containerSize = param.containerSize, containerSize = _containerSize === void 0 ? "sm" : _containerSize, children = param.children;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    title,
                    " | Privacy Horizon"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    backgroundColor: "primary.paper",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    maxWidth: containerSize,
                    sx: {
                        py: 10
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                alt: "PHI Logo",
                                src: theme.palette.mode === "dark" ? "/logos/phi-logo.svg" : "/logos/phi-logo-dark.svg",
                                width: 220,
                                height: 220
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                mb: 8
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    p: 4
                                },
                                children: children
                            })
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 79776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ VerifyCodeStep; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js
var Link = __webpack_require__(47034);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(22715);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(74509);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js
var notistack_esm = __webpack_require__(73400);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/components/form/FormikTextField.tsx
var FormikTextField = __webpack_require__(9952);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(46648);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
// EXTERNAL MODULE: ./src/hooks/useIsMountedRef.ts
var useIsMountedRef = __webpack_require__(60128);
;// CONCATENATED MODULE: ./src/components/authentication/verify-code/VerifyCodeForm.tsx













function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var verifyCodeFormSchema = es/* object */.Ry({
    email: es/* string */.Z_().email("Must be a valid email").max(255).required("Email is required"),
    code: es/* array */.IX().of(es/* string */.Z_().required("Code is required")),
    submit: es/* string */.Z_()
});
var VerifyCodeForm = function(param1) {
    var loginValues = param1.loginValues;
    var isMountedRef = (0,useIsMountedRef/* default */.Z)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var itemsRef = react.useRef([]);
    var router = (0,next_router.useRouter)();
    var ref = (0,useAuth/* default */.Z)(), confirmCode = ref.confirmCode, login = ref.login;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var initialValues = {
        email: loginValues.email,
        code: [
            "",
            "",
            "",
            "",
            "",
            ""
        ]
    };
    react.useEffect(function() {
        itemsRef.current = itemsRef.current.slice(0, 6);
    }, []);
    var handleVerifyCodeSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values, param) {
            var setErrors, setSubmitting;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setErrors = param.setErrors, setSubmitting = param.setSubmitting;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return confirmCode({
                            code: values.code,
                            email: values.email
                        });
                    case 4:
                        enqueueSnackbar("Account Verified", {
                            variant: "success"
                        });
                        _ctx.next = 7;
                        return login({
                            email: loginValues.email,
                            password: loginValues.password
                        });
                    case 7:
                        router.push(routes/* ROUTES.PLAN_SELECTION */.Z.PLAN_SELECTION);
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        if (isMountedRef.current) {
                            setErrors({
                                submit: "Code verification failed"
                            });
                            setSubmitting(false);
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function handleVerifyCodeSubmit(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: initialValues,
        validationSchema: verifyCodeFormSchema,
        onSubmit: handleVerifyCodeSubmit,
        children: function(param) {
            var errors = param.errors, handleBlur = param.handleBlur, isSubmitting = param.isSubmitting, setFieldValue = param.setFieldValue, touched = param.touched, values = param.values;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        autoFocus: true,
                        fullWidth: true,
                        label: t("verify_code.email"),
                        margin: "normal",
                        name: "email",
                        type: "email",
                        value: values.email,
                        disabled: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "textSecondary",
                        sx: {
                            mb: 2,
                            mt: 3
                        },
                        variant: "subtitle2",
                        children: t("verify_code.verification_code")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "grid",
                            columnGap: "16px",
                            gridTemplateColumns: "repeat(7, 1fr)",
                            pt: 1
                        },
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6
                        ].map(function(ref, i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                error: Boolean(Array.isArray(touched.code) && touched.code.length === 6 && errors.code),
                                fullWidth: true,
                                inputRef: function(el) {
                                    itemsRef.current[i] = el;
                                },
                                name: "code[".concat(i, "]"),
                                onBlur: handleBlur,
                                onKeyDown: function(event) {
                                    if (event.code === "ENTER") {
                                        if (values.code[i]) {
                                            setFieldValue("code[".concat(i, "]"), "");
                                            return;
                                        }
                                        if (i > 0) {
                                            setFieldValue("code[".concat(i, "]"), "");
                                            itemsRef.current[i - 1].focus();
                                            return;
                                        }
                                    }
                                    if (Number.isInteger(parseInt(event.key, 10))) {
                                        setFieldValue("code[".concat(i, "]"), event.key);
                                        if (i < 5) {
                                            itemsRef.current[i + 1].focus();
                                        }
                                    }
                                },
                                onPaste: function(event) {
                                    var paste = event.clipboardData.getData("text");
                                    var pasteArray = paste.split("");
                                    if (pasteArray.length !== 6) {
                                        return;
                                    }
                                    var valid = pasteArray.every(function(x) {
                                        return Number.isInteger(parseInt(x, 10));
                                    });
                                    if (valid) {
                                        setFieldValue("code", pasteArray);
                                        itemsRef.current[5].focus();
                                    }
                                },
                                value: values.code[i],
                                sx: {
                                    display: "inline-block",
                                    textAlign: "center",
                                    "& .MuiInputBase-input": {
                                        textAlign: "center"
                                    }
                                },
                                variant: "outlined"
                            }, "code-".concat(i));
                        })
                    }),
                    Array.isArray(touched.code) && touched.code.length === 6 && Boolean(errors.code) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                        error: true,
                        sx: {
                            mx: "14px"
                        },
                        children: Array.isArray(errors.code) && errors.code[0]
                    }),
                    errors.submit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            error: true,
                            children: errors.submit
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            color: "secondary",
                            disabled: isSubmitting,
                            fullWidth: true,
                            size: "large",
                            type: "submit",
                            variant: "contained",
                            children: t("verify_code.verify")
                        })
                    })
                ]
            });
        }
    }));
};

;// CONCATENATED MODULE: ./src/components/authentication/verify-code/index.tsx





var VerifyCodeStep = function(param) {
    var loginValues = param.loginValues;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textPrimary",
                            gutterBottom: true,
                            variant: "h4",
                            children: t("verify_code.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textSecondary",
                            variant: "body2",
                            children: t("verify_code.subtitle")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    flexGrow: 1,
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyCodeForm, {
                    loginValues: loginValues
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    my: 3
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                color: "textSecondary",
                variant: "body2",
                children: t("verify_code.send_again")
            })
        ]
    }));
};


/***/ }),

/***/ 2072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FormikCheckField; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53640);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20847);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58128);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74509);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FormikCheckField = function(props) {
    var checkboxProps = props.checkboxProps, rest = _objectWithoutProperties(props, [
        "checkboxProps"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .FastField */ .Rt, {
        name: rest.name,
        children: function(param) {
            var field = param.field, meta = param.meta;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
                        sx: {
                            mt: 1
                        }
                    }, rest, {
                        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread({
                            "data-testid": rest.name,
                            checked: meta.value,
                            color: "primary"
                        }, checkboxProps, field))
                    })),
                    Boolean(meta.touched && meta.error) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        error: true,
                        children: meta.error
                    })
                ]
            });
        }
    }));
};



/***/ }),

/***/ 8657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ FieldWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var FieldWrapper = function(param) {
    var children = param.children, name = param.name, fast = param.fast;
    if (fast) return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .FastField */ .Rt, {
        name: name,
        children: children
    }));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
        name: name,
        children: children
    }));
};


/***/ }),

/***/ 9952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FormikTextField; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22715);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _FormikFastFieldWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8657);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _fullWidth;
var FormikTextField = function(_param) /*#__PURE__*/ {
    var _fast = _param.fast, fast = _fast === void 0 ? true : _fast, props = _objectWithoutProperties(_param, [
        "fast"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormikFastFieldWrapper__WEBPACK_IMPORTED_MODULE_2__/* .FieldWrapper */ .n, {
        name: props.name,
        fast: fast,
        children: function(param) {
            var field = param.field, meta = param.meta;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({
                "data-testid": props.name,
                error: Boolean(meta.touched && meta.error),
                helperText: meta.touched && meta.error,
                variant: "outlined",
                fullWidth: (_fullWidth = props.fullWidth) !== null && _fullWidth !== void 0 ? _fullWidth : true
            }, field, props, {
                onChange: function(e) {
                    if (props.regex) {
                        if (props.regex.test(e.target.value)) {
                            field.onChange(e);
                        }
                    } else {
                        field.onChange(e);
                    }
                }
            }));
        }
    });
};



/***/ }),

/***/ 46648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ROUTES; }
/* harmony export */ });
/**
 * Global routes table
 */ var ROUTES = {
    AUTH_LOGIN: "/auth/login",
    AUTH_FORGOT_PASSWORD: "/auth/forgot-password",
    AUTH_REGISTER: "/auth/register",
    AUTH_RESET_PASSWORD: "/auth/forgot-password-reset",
    AUTH_VERIFY_MFA: "/auth/verify-mfa",
    PLAN_SELECTION: "/plan-selection",
    PAYMENTS: "/payments",
    DASHBOARD: "/dashboard",
    RISK_REGISTRY: "/risk-registry",
    TRAINING: "/training",
    TRAINING_HUMAN_RISK: "/training/risk",
    TRAINING_TRAINING: "/training/training",
    DOCUMENTS: "/documents",
    COACH: "/coach",
    CHAT: "/chat",
    ORGANIZATIONS: "/organizations",
    CLIENTS: "/clients",
    CLIENTS_CREATE: "/clients/create",
    PHI_SETTINGS: "/phi-settings",
    ADMIN_DASHBOARD: "/admin-dashboard",
    COACH_DASHBOARD: "/coach-dashboard",
    RESOURCES: "/resources",
    RESOURCES_CREATE: "/resources/create",
    INCIDENT_MANAGEMENT: "/incident-management",
    INCIDENT_MANAGEMENT_SETTINGS: "/incident-management/settings",
    POLICY_TEMPLATES: "/policy-templates",
    ADMIN_POLICY_CREATE: "/policy-templates/create",
    ASSESSMENT_TEMPLATES: "/assessment-templates",
    CONTROL_TASK_TEMPLATES: "/controls",
    CONTROL_TASK_TEMPLATE_CREATE: "/controls/create",
    POLICIES: "/policies",
    POLICY_CREATE: "/policies/create",
    ASSESSMENTS: "/assessments",
    ASSESSMENT_CREATE: "/assessments/create",
    UNAUTHORIZED: "/unauthorized",
    PROFILE_USER: "/profile/user",
    PROFILE_ORGANIZATION: "/profile/organization",
    COMMUNITY: "/community",
    NOT_FOUND: "/404"
};


/***/ }),

/***/ 78470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71463);


var useAuth = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 60128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIsMountedRef = function() {
    var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMountedRef);


/***/ }),

/***/ 9679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ PasswordValidation; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var PasswordValidation = yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(8, "Must be at least 8 characters").max(255).required("Required").matches(/(?=.*[A-Z])/gu, "Must have at least one uppercase").matches(/(?=.*[a-z])/gu, "Must have at least one lowercase").matches(/(?=.*[0-9])/gu, "Must have at least one digit").matches(/(?=.*\W)/gu, "Must have at least one symbol").matches(/^\S*$/gu, "Cannot contain spaces or other whitespace characters");


/***/ })

}]);